import { ReactElement } from 'react';
import { DashboardContainer } from '../../../../modules/common/dashboard/DashboardContainer';
import { AttachmentsHeader } from '../../../modules/attachments/components/AttachmentsHeader';
import { AttachmentsListContainer } from '../../../modules/attachments/containers/AttachmentsList.container';

export const AttachmentsView = (): ReactElement => (
  <DashboardContainer>
    <AttachmentsHeader />
    <AttachmentsListContainer addFolderEnabled={true} />
  </DashboardContainer>
);

export const AttachmentsFolderView = (): ReactElement => (
  <DashboardContainer>
    <AttachmentsHeader />
    <AttachmentsListContainer addFolderEnabled={false} />
  </DashboardContainer>
);
